/* ##############################################################################
#
#   Ant Design v5
#   Customize theme and tokens: 
#   https://ant.design/docs/react/customize-theme#seedtoken
#
############################################################################### */

import { type ThemeConfig } from 'antd';

const palette = {
  colorPrimary: '#1677ff',
  colorError: '#ff4d4f',
  colorInfo: '#1677ff',
  colorSuccess: '#52c41a',
  colorSuccessDark: '#237804',
  colorWarning: '#faad14',
  colorWhite: '#ffffff',
  colorText: 'rgba(0,0,0, 0.88)',
  colorIcon: 'rgba(0,0,0, 0.45)',
  colorDisabled: 'rgba(0,0,0, 0.25)',
  colorBorder: '#d9d9d9',
};

const commonThemeConfig: ThemeConfig = {
  token: {
    fontFamily: 'Arial',
    screenSMMax: 743,
    screenMD: 744,
    screenMDMin: 744,
    screenMDMax: 1023,
    screenLG: 1024,
    screenLGMin: 1024,
    screenLGMax: 1279,
    screenXL: 1280,
    screenXLMin: 1280,
    screenXLMax: 1439,
    screenXXL: 1440,
    screenXXLMin: 1440,
  },
  components: {
    Breadcrumb: {
      separatorMargin: 12,
      colorBgTextHover: 'transparent',
    },
    Modal: {
      zIndexPopupBase: 1050,
      marginXS: 16,
    },
    Steps: {
      descriptionMaxWidth: 200,
    },
    Avatar: {},
    Menu: {
      zIndexPopup: 1010,
    },
    Typography: {
      fontWeightStrong: 500,
      fontSizeHeading4: 18,
    },
    Card: {
      headerFontSize: 14,
    },
    Input: {},
    Button: {},
    Badge: {
      paddingXS: 4,
    },
    Table: {
      margin: 8,
      cellPaddingBlock: 8,
      cellPaddingInline: 8,
    },
    Form: {
      labelColonMarginInlineStart: 4,
    },
    Collapse: {
      borderRadiusLG: 0,
      padding: 24,
      contentPadding: 24,
    },
    Alert: {
      borderRadiusLG: 0,
    },
  },
};

export const antdLightTheme: ThemeConfig = {
  ...commonThemeConfig,
  token: {
    ...commonThemeConfig.token,
    colorPrimary: palette.colorPrimary,
    colorError: palette.colorError,
    colorInfo: palette.colorInfo,
    colorSuccess: palette.colorSuccess,
    colorWarning: palette.colorWarning,
    colorWhite: palette.colorWhite,
    colorText: palette.colorText,
  },
  components: {
    ...commonThemeConfig.components,
    Layout: {
      headerBg: palette.colorText,
    },
    Steps: {
      ...commonThemeConfig.components?.Steps,
      colorPrimary: palette.colorPrimary,
    },
    Typography: {
      ...commonThemeConfig.components?.Typography,
      colorSuccess: palette.colorSuccessDark,
    },
    Collapse: {
      ...commonThemeConfig.components?.Collapse,
      headerBg: palette.colorWhite,
    },
  },
};

export const antdDarkTheme: ThemeConfig = {
  ...commonThemeConfig,
  token: {
    ...commonThemeConfig.token,
    colorText: palette.colorWhite,
  },
};
